import {isNil} from 'ramda';

import {PromotionalPhotoResponseBody} from '@dms/api/shared';
import {
  FinancingStatusResponseBodySaleVehiclePhoto,
  SaleVehiclePromoPhotoResponseBody,
} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

/**
 * Builds a gallery tile for each financing card linked to the vehicle that has no rendered file.
 * The tile takes the link's position, so it sits where the card will appear once it is READY.
 * A card without a status entry is skipped until the financing status loads.
 */
export const buildFinancingPlaceholders = (
  promoPhotos: SaleVehiclePromoPhotoResponseBody[],
  financingStatus: FinancingStatusResponseBodySaleVehiclePhoto[],
  promoPhotoConfigs: Pick<PromotionalPhotoResponseBody, 'id' | 'sourcePhotoIndex'>[]
) =>
  promoPhotos.flatMap((promoPhoto): UnifiedAlbumImage[] => {
    const status = financingStatus.find(
      (entry) => entry.promotionalPhotoId === promoPhoto.promotionalPhotoId
    );

    if (
      promoPhoto.type !== 'FINANCING' ||
      !isNil(promoPhoto.fileId) ||
      isNil(status) ||
      status.status === 'READY'
    ) {
      return [];
    }

    const config = promoPhotoConfigs.find((item) => item.id === promoPhoto.promotionalPhotoId);

    return [
      {
        id: promoPhoto.id,
        fileId: '',
        remoteFileId: '',
        url: '',
        latestFileOperation: null,
        weight: promoPhoto.position,
        position: promoPhoto.position,
        positionInSettings: promoPhoto.positionInSettings,
        promotionalPhotoId: promoPhoto.promotionalPhotoId,
        isCoverPhoto: false,
        isPromoPhoto: true,
        isCampaignPhoto: false,
        financingPlaceholder: {
          status: status.status,
          reason: status.reason,
          financialProductType: status.financialProductType,
          sourcePhotoIndex: config?.sourcePhotoIndex ?? null,
        },
      },
    ];
  });
